import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentSettingsAdapter } from 'app/core/adapters/payment-settings.adapter';
import { PaymentSettings } from 'app/core/interfaces/payment-settings';
import { environment } from 'app/environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentSettingsService {
  constructor(
    private http: HttpClient,
    private paymentSettingsAdapter: PaymentSettingsAdapter,
  ) {}

  create(paymentSettings: PaymentSettings): Observable<PaymentSettings> {
    const paymentSettingsAPI = this.paymentSettingsAdapter.adaptToAPIFormat(paymentSettings);

    return this.http
      .post<PaymentSettings>(`${environment.apiUrl}/secretarias-payment/settings`, paymentSettingsAPI)
      .pipe(map((paymentSettings: PaymentSettings) => this.paymentSettingsAdapter.adapterToModel(paymentSettings)));
  }

  update(paymentSettings: PaymentSettings, payment_settings_id: string): Observable<PaymentSettings> {
    const paymentSettingsAPI = this.paymentSettingsAdapter.adaptToAPIFormat(paymentSettings);

    const payload: PaymentSettings = {
      ...paymentSettingsAPI,
      healthcare_plans: Array.isArray(paymentSettingsAPI.healthcare_plans) ? paymentSettingsAPI.healthcare_plans : [],
    };

    return this.http
      .put<PaymentSettings>(`${environment.apiUrl}/secretarias-payment/settings/${payment_settings_id}`, payload)
      .pipe(map((paymentSettings: PaymentSettings) => this.paymentSettingsAdapter.adapterToModel(paymentSettings)));
  }

  findByOrganization(organization_id: string): Observable<PaymentSettings> {
    return this.http
      .get<PaymentSettings>(`${environment.apiUrl}/secretarias-payment/settings/${organization_id}`)
      .pipe(map((paymentSettingsAPI: PaymentSettings) => this.paymentSettingsAdapter.adapterToModel(paymentSettingsAPI)));
  }
}
